var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-menu-item',{attrs:{"target-path":"balance","title":"יתרת העו״ש וחיובי האשראי","disabled":!_vm.allowNavigationToBalancePage},on:{"navigate":function($event){return _vm.$emit('navigate')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695e23e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/app-header/BalancePageMenuItem.vue
// module id = null
// module chunks = 